export default __webpack_public_path__ + "static/media/app-store.9fd8f578.svg";